import Digits from '@/server/helpers/currency/Digits';

const useCurrencyDigits = (maximumFractionDigits?: number) => ({
  min: Digits.MINIMUM,
  max: maximumFractionDigits ?? Digits.MAXIMUM,
});

export default useCurrencyDigits;
